import styled from "styled-components";
import { fontQuicksand } from "../../components/purchase/mixin";

export const Wrapper = styled.div`
    margin:0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    background : ${props => props.noBackground === true ? "unset" : deepCoveDark};
    ${fontQuicksand()};
`